import { useQuery } from "@tanstack/react-query";

import { getRole } from "@/services/api/role/actions";

export const useRoleQuery = (roleId: string | number | undefined) => {
  return useQuery({
    queryKey: ["role", "detail", `${roleId}`],
    queryFn: () => getRole(String(roleId!)),
    enabled: !!roleId,
  });
};
